const ReportJob = `
  id
  userId
  correlationId
  type
  report
  format
  status
  progressCurrent
  progressTotal
  filename
  error
  downloadUrl
  payload
  attempts
  lastAttemptAt
  canRetry
  contents {
    totalCount
    resolved
    items {
      id
      title
      subtitle
      thumbnailUrl
    }
  }
  createdAt
  startedAt
  cancelRequestedAt
  cancelledAt
  cancelledByUserId
  completedAt
`;

export default ReportJob;
